<div class="w-100 h-100 error-page" [ngSwitch]="errorType">
  <div *ngSwitchCase="permission" class="row w-100 h-100">
    <div class="col-12 p-0 d-flex ai-center mb-1">
      <app-back-link
        [page]="requestsListLink"
        [label]="'module.requests.label.link-requests' | translate"
        testId="button_list_back"
      ></app-back-link>
    </div>
    <div class="col-12 p-0 d-flex column ai-center jc-center">
      <span class="icon icon-permission color-gray"></span>
      <p class="m-0 mt-1 fs-md">{{'common.errors.permission' | translate}}</p>
      <p class="m-0 fs-md">{{'common.errors.permission-desc' | translate}}&nbsp;
        <a href="{{requestsListLink}}" class="color-green">{{'common.errors.back-to-list' | translate}}</a>.</p>
    </div>
  </div>
  <div *ngSwitchCase="notFound" class="row w-100 h-100">
    <div class="col-12 p-0 d-flex ai-center mb-1">
      <app-back-link
        [page]="requestsListLink"
        [label]="'module.requests.label.link-requests' | translate"
        testId="button_list_back"
      ></app-back-link>
    </div>
    <div class="col-12 p-0 d-flex column ai-center jc-center">
      <span class="icon icon-file-rejected color-gray"></span>
      <p class="m-0 mt-1 fs-md">{{'common.errors.not-found' | translate}}</p>
      <p class="m-0 fs-md">{{'common.errors.permission-desc' | translate}}&nbsp;
        <a href="{{requestsListLink}}" class="color-green">{{'common.errors.back-to-list' | translate}}</a>.</p>
    </div>
  </div>
  <div *ngSwitchCase="serviceUnavailable" class="row w-100 h-100">
    <div class="col-12 p-0 d-flex column ai-center jc-center">
      <span class="icon icon-file-rejected color-gray"></span>
      <p class="m-0 mt-1 fs-md" [innerHTML]="'common.errors.service-unavailable-desc' | translate"></p>
      <p>
        <span>{{'common.label.please'|translate}}</span>
        <button class="reset-button link fs-md"
                data-test-id="error_try_again"
                (click)="reload()">{{'common.label.try-again' | translate}}</button>
        <span>{{'common.label.or-contact'|translate}}</span> 
        <button class="reset-button link fs-md"
                data-test-id="error_system_admin"
                (click)="redirect()">{{'common.label.system-admin' | translate}}</button>       
      </p>
    </div>
  </div>
  <div *ngSwitchDefault class="row w-100 h-100">
    <div class="col-12 p-0 d-flex ai-center mb-1">
      <app-back-link
        [page]="requestsListLink"
        [label]="'module.requests.label.link-requests' | translate"
        testId="button_list_back"
      ></app-back-link>
    </div>
    <div class="col-12 p-0 d-flex column ai-center jc-center">
      <span class="icon icon-error color-gray"></span>
      <p class="m-0 mt-1 fs-md">{{'common.errors.authorization' | translate}}</p>
    </div>
  </div>
</div>
